import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import AOS from 'aos';
import 'aos/dist/aos.css';

const About = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <div className="pt-16">
      {/* Hero Section */}
      <section className="relative bg-blue-50 py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center"
          >
            <h1 className="text-4xl font-bold text-gray-900 mb-6">About APPTARGET ADVERTISING</h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Your trusted partner in performance marketing and app advertising. We connect brands with their ideal audiences through innovative, data-driven advertising solutions.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div data-aos="fade-right">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Our Vision & Mission</h2>
              <p className="text-lg text-gray-600 mb-6">
                Our vision is to deliver meaningful value to clients, partners, and employees by being at the forefront of digital advertising innovation. We strive to create lasting impact through performance-focused solutions.
              </p>
              <p className="text-lg text-gray-600">
                At APPTARGET, our mission is to enable brands with innovative, performance-focused advertising solutions that drive measurable results. We combine advanced technology, strategic insights, and creative excellence to deliver exceptional ROI for our clients.
              </p>
            </div>
            <div data-aos="fade-left" className="relative">
              <img
                src="/images/ourmission.png"
                alt="Our Mission"
                className="w-full rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="bg-gray-50 py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 text-center mb-16">Our Values</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {values.map((value, index) => (
              <div
                key={value.title}
                className="bg-white p-8 rounded-xl shadow-lg"
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <div className="text-4xl mb-4">{value.icon}</div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">{value.title}</h3>
                <p className="text-gray-600">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

const values = [
  {
    icon: '📊',
    title: 'Data-Driven',
    description: 'We leverage advanced analytics and real-time data to optimize campaigns and deliver measurable results.',
  },
  {
    icon: '🌐',
    title: 'Global Reach',
    description: 'Access to premium advertising networks and partnerships worldwide to scale your app globally.',
  },
  {
    icon: '💡',
    title: 'Innovation',
    description: 'Constantly evolving our strategies and technologies to stay ahead in the dynamic digital advertising landscape.',
  },
  {
    icon: '🤝',
    title: 'Partnership',
    description: 'Building lasting relationships through transparency, trust, and consistent performance delivery.',
  },
];

export default About;
